import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles({
  noItem: {
    color: '#414141',
    fontSize: '1.125rem',
    fontWeight: 500,
  },
})
